/** @jsx jsx */
import { Grid, jsx, Link, Box, Image } from "theme-ui";
import covidBannerLogo from "../../static/imgs/covid-footer-magazine-img.png";

const CovidFooter = () => {
  const footerLinks = {
    Institute: [
      { title: "Education", link: "https://heartfulness.org/education" },
      {
        title: "Continual Medical Education",
        link: "https://heartfulness.org/cme",
      },
      {
        title: "Yoga Teachers Training Certification",
        link: "http://heartfulness.org/education/yoga-trainers",
      },
      {
        title: "Heartfulness Research",
        link: "http://research.heartfulness.org/in/",
      },
    ],
    "Quick Links": [
      { title: "Daaji", link: "http://www.daaji.org/" },
      { title: "Sahal Marg", link: "http://sahajmarg.org/" },
      { title: "Kanha Shanti Vanam", link: "https://kanha.sahajmarg.org/" },
      { title: "Green Kanha", link: "https://kanha.sahajmarg.org/green-kanha" },
      { title: "Shri Ram Chandra Mission", link: "http://www.srcm.org/" },
      {
        title: "Spirituality Foundation",
        link: "http://www.spiritualityfoundation.org/",
      },
    ],
    "Related Links": [
      { title: "Publications", link: "https://www.hfnlife.com/" },
      {
        title: "Digital Store",
        link: "https://www.shriramchandramission.org//digitalstore/",
      },
      { title: "HFN Life Online Store", link: "http://www.hfnlife.com/" },
    ],
  };

  return (
    <div
      sx={{
        background: "#454E57",
        padding: ["1em 3em 1em 3em", "4em 6em 1em 6em"],
        borderTop: "1px solid #c6c6c6",
        a: {
          color: "white",
          ":hover": {
            opacity: "0.6",
            textDecoration: "none",
          },
        },
      }}
    >
      <Grid gap={3} columns={[1, 2, 4]}>
        {Object.keys(footerLinks).map((key) => (
          <Box key={key}>
            <div
              sx={{
                textTransform: "uppercase",
                fontWeight: "bolder",
                color: "#FFFFFF",
              }}
            >
              {key}
            </div>
            <br />
            {footerLinks[key].map((links) => {
              return (
                <div key={links.title} sx={{ lineHeight: "37px" }}>
                  <Link
                    sx={{ cursor: "pointer", color: "#CCC7D4" }}
                    key={links.title}
                    href={links.link}
                  >
                    {links.title}
                  </Link>
                </div>
              );
            })}
          </Box>
        ))}
        <Box>
          <Image src={covidBannerLogo} />
          <div
            sx={{
              mt: 3,
              textTransform: "uppercase",
              fontWeight: "bolder",
              color: "#FFFFFF",
            }}
          >
            Heartfulness Magazine
          </div>
        </Box>
      </Grid>
      <Grid columns={[1, null, 2]} sx={{ mt: 5, mb: 5 }}>
        <Box sx={{ fontWeight: "bolder", color: "#FFFFFF", fontSize: "20px" }}>
          Heartfulness practices with a certified trainer are always free,
          whether in person or online.
        </Box>
        <Box />
      </Grid>
      <Grid
        columns={[1, 2, null]}
        sx={{
          textAlign: ["center", "initial", null],
          mt: 5,
          mb: 5,
          color: "#CCC7D4",
          fontSize: "14px",
        }}
      >
        <Box>
          © Copyright 2020 Sahaj Marg Spirituality Foundation, All Rights
          Reserved.
        </Box>
        <Box sx={{ cursor: "pointer", textAlign: ["center", null, "right"] }}>
          <a
            target="_blank"
            href="https://heartfulness.org/en/terms/"
            sx={{ color: "#FFFFFF" }}
            rel="noreferrer"
          >
            Terms of Use
          </a>
          and
          <a
            target="_blank"
            href="https://heartfulness.org/en/privacy-policy/"
            sx={{ color: "#FFFFFF" }}
            rel="noreferrer"
          >
            Privacy & Cookie Policy
          </a>
          .
        </Box>
      </Grid>
    </div>
  );
};

export default CovidFooter;
